(function () {
  'use strict';

  var predictive = document.getElementById('search-predictive');
  if (!predictive) return;

  var input = predictive.querySelector('[data-search-predictive-input]');
  var results = predictive.querySelector('[data-search-predictive-results]');
  var timer = null;
  var lastQuery = '';
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    predictive.classList.add('is-open');
    predictive.setAttribute('aria-hidden', 'false');
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { input && input.focus(); }, 200);
  }

  function close() {
    predictive.classList.remove('is-open');
    predictive.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) lastFocus.focus();
  }

  function renderEmpty(msg) {
    results.innerHTML = '<div class="search-predictive__empty">' + msg + '</div>';
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-IE', { style: 'currency', currency: 'EUR' });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function render(payload, query) {
    var products = (payload.resources && payload.resources.results && payload.resources.results.products) || [];
    var articles = (payload.resources && payload.resources.results && payload.resources.results.articles) || [];
    var collections = (payload.resources && payload.resources.results && payload.resources.results.collections) || [];
    var pages = (payload.resources && payload.resources.results && payload.resources.results.pages) || [];

    if (!products.length && !articles.length && !collections.length && !pages.length) {
      renderEmpty('No results for "' + escapeHtml(query) + '".');
      return;
    }

    var html = '';

    if (products.length) {
      html += '<div class="search-predictive__section">';
      html += '<p class="search-predictive__section-title">Pieces</p>';
      products.forEach(function (p) {
        var img = p.featured_image ? p.featured_image.url : (p.image || '');
        html += '<a href="' + p.url + '" class="search-predictive__product">';
        html += '<div class="search-predictive__product-fig">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>';
        html += '<div>';
        html += '<div class="search-predictive__product-name">' + escapeHtml(p.title) + '</div>';
        if (p.vendor) html += '<div class="search-predictive__product-price" style="font-size:10.5px; letter-spacing:0.24em; text-transform:uppercase;">' + escapeHtml(p.vendor) + '</div>';
        html += '</div>';
        html += '<div class="search-predictive__product-price">' + formatMoney(p.price) + '</div>';
        html += '</a>';
      });
      html += '</div>';
    }

    if (collections.length) {
      html += '<div class="search-predictive__section">';
      html += '<p class="search-predictive__section-title">Edits</p>';
      collections.forEach(function (c) {
        html += '<a href="' + c.url + '" class="search-predictive__link">' + escapeHtml(c.title) + '</a>';
      });
      html += '</div>';
    }

    if (articles.length) {
      html += '<div class="search-predictive__section">';
      html += '<p class="search-predictive__section-title">From the letters</p>';
      articles.forEach(function (a) {
        html += '<a href="' + a.url + '" class="search-predictive__link">' + escapeHtml(a.title) + '</a>';
      });
      html += '</div>';
    }

    if (pages.length) {
      html += '<div class="search-predictive__section">';
      html += '<p class="search-predictive__section-title">Pages</p>';
      pages.forEach(function (pg) {
        html += '<a href="' + pg.url + '" class="search-predictive__link">' + escapeHtml(pg.title) + '</a>';
      });
      html += '</div>';
    }

    html += '<div class="search-predictive__section"><a href="/search?q=' + encodeURIComponent(query) + '" class="search-predictive__link" style="font-weight:500;">View all results →</a></div>';

    results.innerHTML = html;
  }

  function search(query) {
    if (query === lastQuery) return;
    lastQuery = query;
    if (!query || query.length < 2) {
      renderEmpty('Start typing to search.');
      return;
    }
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) +
              '&resources[type]=product,article,page,collection' +
              '&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (payload) { render(payload, query); })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      open();
      return;
    }
    if (e.target.closest('[data-search-close]')) {
      e.preventDefault();
      close();
      return;
    }
    if (predictive.classList.contains('is-open') && !predictive.contains(e.target) && !e.target.closest('[data-search-open]')) {
      close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && predictive.classList.contains('is-open')) close();
    if (e.key === '/' && !predictive.classList.contains('is-open') && document.activeElement.tagName !== 'INPUT' && document.activeElement.tagName !== 'TEXTAREA') {
      e.preventDefault();
      open();
    }
  });

  if (input) {
    input.addEventListener('input', function () {
      if (timer) clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { search(q); }, 180);
    });
  }
})();
